import { Badge, BadgeColour, BadgeSize } from '@xemplo/badge';
import { Button, ButtonIconPosition, ButtonSize, ButtonType } from '@xemplo/button';
import { DawnAddPlus } from '@xemplo/icons';
import { MaybeTooltip, TooltipPlacement } from '@xemplo/tooltip';

import * as S from '../common/common.styles';

import { useAddTag } from './use-add-tag';

export function AddTag() {
  const { isVisible, isValid, validationMsg, search, onTagCreate } = useAddTag();
  if (!isVisible) return null;

  return (
    <S.AddTagWrapper onClick={() => onTagCreate(search)}>
      <Badge
        size={BadgeSize.Small}
        value={search}
        className="ellipsis"
        color={BadgeColour.Gray}
      />
      <MaybeTooltip
        isEnabled={!isValid}
        text={validationMsg}
        placement={TooltipPlacement.TopLeft}
      >
        <Button
          size={ButtonSize.Small}
          type={ButtonType.Tertiary}
          ariaLabel={'Add tag button'}
          icon={<DawnAddPlus />}
          iconPosition={ButtonIconPosition.Leading}
          disabled={!isValid}
        >
          Add
        </Button>
      </MaybeTooltip>
    </S.AddTagWrapper>
  );
}
